import React from 'react';

import './index.scss';

import CrossIcon from 'components/atoms/Icon/CrossIcon';
import ClickOnlyButton from 'components/atoms/Button/ClickOnlyButton';
import SpInputTitle from 'components/molecules/SpInputTitle';
import PcErrorArea from 'components/molecules/PcErrorArea';

const SpModal = ({
  modalIsOpen,
  errorDispMessages,
  content,
  button,
  onClickCloseButton,
  selectedDate,
  comment,
  radioChild
}) => {
  if (modalIsOpen) {
    return (
      <div className="SM-overlay" onClick={onClickCloseButton}>
        <div className="SM-content" onClick={(e) => e.stopPropagation()}>
          <div className="SM-wrapper">
            <div className="SM-information">
                <SpInputTitle title={content.title} list={content.list} label={content.label} questionMark={content.questionMark} popUpTitle={content.popUpTitle} popUpDetail={content.popUpDetail} type={content.type} selectedDate={selectedDate} errorDispMessages={errorDispMessages} comment={comment} radioChild={radioChild} />
              <div className="SM-next-button">
                <ClickOnlyButton label={button.label} onClick={button.onClick} valid={button.valid} />
              </div>
            </div>
            <button className="SM-close-button" type="button" onClick={onClickCloseButton}><CrossIcon /></button>
          </div>
        </div>
      </div>
    );
  }
  return null;
};

export default SpModal;